import Cookies from 'js-cookie';
import actions from './actions';

const {
  LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_ERR,
  UPDATE_PROFILE_BEGIN, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_ERR,
  UPDATE_PASSWORD_BEGIN, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_ERR,
  FORGOT_PASSWORD_BEGIN, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERR,
  LOGOUT_BEGIN, LOGOUT_SUCCESS, LOGOUT_ERR
} = actions;

const initState = {
  login: Cookies.get('logedIn'),
  user: {},
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: true,
        user: data || {},
        loading: false,
      };
    case LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case FORGOT_PASSWORD_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case FORGOT_PASSWORD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_PROFILE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        user: data,
        loading: false,
      };
    case UPDATE_PROFILE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_PASSWORD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        user: data,
        loading: false,
      };
    case UPDATE_PASSWORD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        login: null,
        user: {},
        loading: false,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default AuthReducer;
